import React from 'react';
import bgMyMatchPilot from './img/backgrounds/bg-mymatchpilot.png';
import bgSomnus from './img/backgrounds/bg-somnus.png';

function App() {
  return (
    <div className="group flex flex-col md:flex-row min-h-screen">
      {/* MyMatchpilot */}
      <div
        // href="https://mymatchpilot.mfinit.de/"
        target="_blank"
        rel="noopener noreferrer"
        className="
          flex flex-1 md:h-screen flex-col justify-center items-center text-center p-10
          cursor-pointer relative overflow-hidden
          transition-all duration-500 ease-out
          text-[#cbb27b]

          md:group-hover:grayscale
          md:group-hover:brightness-75

          md:hover:!grayscale-0
          md:hover:!brightness-100
          md:hover:scale-105
        "
        style={{
          backgroundImage: `url(${bgMyMatchPilot})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h2 className="text-4xl mb-4 font-bold">MyMatchpilot</h2>

        <img
          src="/logos/logo-mymatchpilot.png"
          alt="MyMatchPlan Logo"
          className="max-w-[250px] h-auto my-6"
        />

        <p className="text-lg max-w-[80%] leading-relaxed mt-4">
          A interactive tournament live dashboard.
        </p>
        <p>Coming soon!</p>
      </div>

      {/* Somnus */}
      <div
        // href="https://somnus.mfinit.de/"
        target="_blank"
        rel="noopener noreferrer"
        className="
          flex flex-1 md:h-screen flex-col justify-center items-center text-center p-10
          cursor-pointer relative overflow-hidden
          transition-all duration-500 ease-out
          text-pink-200

          md:group-hover:grayscale
          md:group-hover:brightness-75

          md:hover:!grayscale-0
          md:hover:!brightness-100
          md:hover:rotate-2
          md:hover:scale-105
        "
        style={{
          backgroundImage: `url(${bgSomnus})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h2 className="text-4xl mb-4 font-bold">Somnus Clothing</h2>

        <img
          src="/logos/somnus.png"
          alt="Somnus Clothing Logo"
          className="max-w-[250px] h-auto"
        />

        <p className="text-lg max-w-[80%] leading-relaxed mt-4">
          A clothing brand.
        </p>
        <p>Coming soon!</p>
      </div>
    </div>
  );
}

export default App;
